import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { errorHandler } from "../../../helpers/handlers";
import api from "../../../config/axios";
import { logout } from "../auth";
import { uploadDocument } from "../../../config/firebase";

const initialState = {
  searches: [],
  pageLoading: false,
  buttonLoading: false,
};

const slice = createSlice({
  name: "remote-config",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(logout.fulfilled, () => initialState)
      .addCase(fetchQuickSearch.pending, (state) => {
        state.pageLoading = true;
        state.error = null;
      })
      .addCase(fetchQuickSearch.fulfilled, (state, action) => {
        state.pageLoading = false;
        state.searches = action.payload;
        state.error = null;
      })
      .addCase(fetchQuickSearch.rejected, (state, action) => {
        state.pageLoading = false;
        state.error = action.payload;
      })
      .addCase(createQuickSearch.pending, (state) => {
        state.buttonLoading = true;
        state.error = null;
      })
      .addCase(createQuickSearch.fulfilled, (state, action) => {
        state.buttonLoading = false;
        state.searches = action.payload;
        state.error = null;
      })
      .addCase(createQuickSearch.rejected, (state, action) => {
        state.buttonLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteQuickSearch.pending, (state) => {
        state.buttonLoading = true;
        state.error = null;
      })
      .addCase(deleteQuickSearch.fulfilled, (state, action) => {
        state.buttonLoading = false;
        state.searches = action.payload;
        state.error = null;
      })
      .addCase(deleteQuickSearch.rejected, (state, action) => {
        state.buttonLoading = false;
        state.error = action.payload;
      });
  },
});

export const fetchQuickSearch = createAsyncThunk(
  "remote-config/quick-search",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/admin/remote-config/quick-search");
      const result = response.data.payload;
      return result;
    } catch (error) {
      errorHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createQuickSearch = createAsyncThunk(
  "remote-config/new-quick-search",
  async (payload, { rejectWithValue }) => {
    try {
      if (payload.image) {
        console.log("Uploading...", payload.image);
        payload.data.image = await uploadDocument(payload.image);
      }
      const response = await api.post(
        "/admin/remote-config/quick-search",
        payload.data
      );
      return response.data.payload;
    } catch (error) {
      errorHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteQuickSearch = createAsyncThunk(
  "remote-config/delete-quick-search",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(
        `/admin/remote-config/quick-search/${id}`
      );
      return response.data.payload;
    } catch (error) {
      errorHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export default slice.reducer;
